import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AgencyTypeModel } from 'src/app/Model/AgencyType.model';
import { AggregatorModel } from 'src/app/Model/Aggregator.model';
import { ContactTypeModel } from 'src/app/Model/ContactType.model';
import { CountryModel } from 'src/app/Model/Country.model';
import { DocumentTypeModel } from 'src/app/Model/DocumentType.model';
import { RegionModel } from 'src/app/Model/Region.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { RolesArdModel } from 'src/app/Model/RolesArd.model';
import { CountryService } from 'src/app/Services/Country/Country.service';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequestService } from 'src/app/Services/request/request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-access-request',
  templateUrl: './access-request.component.html',
  styleUrls: ['./access-request.component.css']
})
export class AccessRequestComponent {
  request: RequestModel = new RequestModel();
  lstAggregators: AggregatorModel[];
  lstDocumentTypes: DocumentTypeModel[];
  lstRegions: RegionModel[];
  lstContactTypes: ContactTypeModel[];
  lstRolesArd: RolesArdModel[];
  lstAgencyTypes: AgencyTypeModel[];
  lstCountries: CountryModel[];
  constructor( 
    private readonly requestService: RequestService,
    private readonly spinner: NgxSpinnerService,
    private readonly countryService: CountryService,
    private readonly lsService : SessionStorageService) { }

  async ngAfterViewInit(){
   await this.spinner.show();
    let promises = []
    promises.push(this.loadAggregators())
    promises.push(this.loadDocumentTypes())
    promises.push(this.loadContactTypes())
    promises.push(this.loadRolesArd())
    promises.push(this.loadAgencyTypes())
    promises.push(this.loadCountries())
    await Promise.all(promises)
    let idrequest = this.lsService.getLSItem("IdRequest")
    if (idrequest != null) {
      await this.updateRequest(idrequest);
    }
    else{
      await  this.spinner.hide();
      await Swal.fire({
         icon: 'warning',
         text: "Solicitud no encontrada",
         showConfirmButton: true
       })
       window.location.replace(`Register/`);
    }
    this.spinner.hide();
  }
  async updateRequest(id) {
    let rq = await this.requestService.getRequestById(id);
    if (rq != null) {
      this.request = rq;
    } else {
      await Swal.fire({
        title: 'Error!',
        text: "Ha ocurrido un error",
        icon: 'error'
      }
      )

    }
  }
  async loadAggregators() {

    await this.requestService.getAggregators().then(res => {
      this.lstAggregators = res;
    });
  }
  async loadDocumentTypes() {

    await this.requestService.getDocumentTypes().then(res => {
      this.lstDocumentTypes = res;
    });
  }
  async loadContactTypes() {
    await this.requestService.getContactTypes().then(res => {
      this.lstContactTypes = res;
    });
  }
  async loadRolesArd() {
    await this.requestService.getRolesARD().then(res => {
      this.lstRolesArd = res;
    });
  }
  async loadAgencyTypes() {
    await this.requestService.getAgencyTypes().then(res => {
      this.lstAgencyTypes = res;
    });
  }
  async loadCountries() {
    await this.countryService.getCountry().then(res => {
      this.lstCountries = res;
    });
  }
}
